import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/illustrations/link_send.png'


const _hoisted_1 = { class: "_modal bg-white" }
const _hoisted_2 = { class: "_modal__content md-down:px-4 px-12 py-6 flex flex-col items-center justify-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Luca Education",
    title: "Luca Education",
    height: "150",
    width: "150"
  })
], -1)
const _hoisted_4 = { class: "_modal__content__title text-neutral-700 font-semibold text-2xl mt-5" }
const _hoisted_5 = { class: "text-center text-neutral-500 mt-2" }
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = { class: "p-6 bg-white select-tabs" }
const _hoisted_8 = { class: "flex flex-nowrap items-center" }
const _hoisted_9 = { class: "flex flex-nowrap items-center font-medium" }
const _hoisted_10 = { class: "_modal__footer px-12 py-6 bg-neutral-50 flex flex-nowrap items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, " Bạn muốn thêm " + _toDisplayString(_ctx.$filters.terminology('teacher')) + " dạy học sinh này? ", 1),
      _createElementVNode("div", _hoisted_5, " Bạn muốn thêm " + _toDisplayString(_ctx.$filters.terminology('teacher')) + " dạy học sinh này? ", 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_Multiselect, {
          modelValue: _ctx.staffSelected,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.staffSelected) = $event)),
          "deselect-label": "Đã chọn",
          "track-by": "id",
          options: 
						_ctx.staffs?.map((s) => {
							return {
								nameSearch: _ctx.toEnglish(s?.name),
								...s,
							};
						})
					,
          searchable: true,
          label: "nameSearch",
          "allow-empty": false,
          selectLabel: "",
          placeholder: `Chọn ${_ctx.$filters.terminology('teacher')}`
        }, {
          noResult: _withCtx(() => [
            _createTextVNode(" Không tìm thấy kết quả ")
          ]),
          option: _withCtx((props) => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, _toDisplayString(props.option.name), 1)
            ])
          ]),
          singleLabel: _withCtx(({ option }) => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", null, _toDisplayString(option.name), 1)
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "options", "placeholder"])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("button", {
        type: "button",
        class: "button-p text-center mr-3 bg-none shadow-none text-neutral-500 hover:text-neutral-700",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, " Quay lại "),
      _createElementVNode("button", {
        type: "button",
        class: "button-p text-center whitespace-nowrap",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
      }, " Xác nhận ")
    ])
  ]))
}